module.exports = __webpack_public_path__ + "media/shopifyAppLogoDesc.9016f5e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopifyAppLogoDesc.png
// module id = ./src/assets/shopifyAppLogoDesc.png
// module chunks = 0